<template>
  <!-- Legacy -->
  <div class="event-users">
    <modal title="Привязка пользователя" :subtitle="''"
      v-on:close="switchModal"
      v-if="modal">
      <add-user-to-event v-on:close="switchModal"/>
    </modal>
    <div class="users-actions">
      <button v-if="permissionsStatus.isEventUpdateAllowed"
        class="ccs-button ccs-button--white ccs-button--small" @click="switchModal">
        <img src="@/assets/icons/add.svg" alt="" class="button-icon">
        Привязать пользователя
      </button>
    </div>
    <ccs-table :data="eventUsers" :columnsDefs="columnsDefs"
      :defaultActions="defaultActions" @delete="removeUser">
      <template v-slot:labels="props">
        <div v-if="!props.row.labels.data[event.id] || props.row.labels.data[event.id].length === 0">
          Не назначены
        </div>
        <div v-else>
          {{ props.row.labels.data[event.id].join(', ') }}
        </div>
      </template>
    </ccs-table>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';

import Table from '@/components/Table.vue';
import Pagination from '@/components/Pagination.vue';
import Modal from '../../components/Modal.vue';

import AddUserToEvent from '@/components/modals/events/AddUserToEvent.vue';

export default {
  name: 'Roles',
  components: {
    'ccs-table': Table,
    Modal,
    AddUserToEvent,
  },
  data() {
    return {
      modal: false,
      columnsDefs: [
        {
          name: `full_name`,
          title: 'ФИО',
          prop: 'full_name',
        },
        {
          name: `email`,
          title: `Email`,
          prop: `email`,
        },
        {
          name: `labels`,
          title: `Теги`,
          prop: `labels`,
        },
      ],
    };
  },
  computed: {
    ...mapState('events', ['event', 'eventUsers']),
    ...mapState('session', ['permissions']),
    ...mapGetters('session', ['permissionsStatus']),
    defaultActions() {
      return {
        delete: this.permissionsStatus.isEventUpdateAllowed,
      };
    },
  },
  methods: {
    ...mapActions('events', ['deleteUserFromEvent']),
    switchModal() {
      this.modal = !this.modal;
    },
    async removeUser(user) {
      try {
        await this.deleteUserFromEvent(user);
        this.$toasted.success('Пользователь отвязан');
      } catch (err) {
        this.$toasted.error(err);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.event-users {
  min-height: 100%;
  min-width: 100%;

  .users-actions {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .ccs-table {
    margin-top: 20px;
  }

}
</style>
